'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'

import {
	type AnchorLinkProps,
	isValidInternalLinkHref,
	Link,
	type NextLinkProps,
} from '../Link'

type ClientNextLinkProps = Omit<NextLinkProps, 'masterData'>
type ClientAnchorLinkProps = Omit<AnchorLinkProps, 'masterData'>

export type ClientLinkProps = ClientNextLinkProps | ClientAnchorLinkProps

export function ClientLink(props: ClientLinkProps): React.ReactNode {
	const { href, logId } = props
	const masterData = useMasterData()

	if (!isValidInternalLinkHref(href)) {
		console.error(
			`Link(${logId}) with "${href}" url must start with a "/" on internal links`
		)
		return null
	}

	return <Link {...props} masterData={masterData} />
}
